import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";

import CompactNetlifyForm from "components/CompactNetlifyForm/CompactNetlifyForm.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

import styles from "assets/jss/material-kit-react/views/landingPage.js";

// Sections for this page
import ProductSection from "./Sections/ProductSection.js";
// import CognitiveBiaisSection from "./Sections/CognitiveBiaisSection.js";
import FollowUpStatement from "./Sections/FollowUpStatement.js";
// import InfluencesSections from "./Sections/InfluencesSections.js";
import FounderLetterSection from "./Sections/FounderLetterSection.js";
import RegisterEmailSection from "./Sections/RegisterEmailSection.js";

import hero from "assets/img/gifs/hero.gif";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function LandingPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        brand="Live Planner"
        fixed
        changeColorOnScroll={{
          height: 50,
          color: "white",
        }}
        {...rest}
      />
      <Parallax
        filter
        className={classes.parallax}
        image={require("assets/img/landing-bg.avif").default}
      >
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={8} md={4}>
              <h1 className={classes.title}>Plan matters</h1>
              <h4>
                A plan is best to maximize your day, but it takes time and can
                derail so quickly. Live Planner covers that, making your very
                next best plan for the day a click away.
              </h4>
              <br />
            </GridItem>
            <GridItem xs={8} sm={8} md={6}>
              <img
                src={hero}
                alt="..."
                className={
                  classes.imgRaised +
                  " " +
                  classes.imgRounded +
                  " " +
                  classes.imgMaxWidth
                }
              />
            </GridItem>
            <GridItem xs={12} sm={8} md={4}>
              <CompactNetlifyForm />
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <ProductSection />
        {/* <CognitiveBiaisSection /> */}
        <FounderLetterSection />
        <FollowUpStatement />
        {/* <InfluencesSections /> */}
        <RegisterEmailSection />
      </div>
      <Footer />
    </div>
  );
}
